import React from 'react';
import { PartnerDetail } from '../components/PartnerDetail';

// Layout component
const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-background">
    <header className="border-b">
      <div className="container mx-auto px-4 py-4">
        <h1 className="text-2xl font-bold">ProPay Simulator Admin</h1>
      </div>
    </header>
    <main className="container mx-auto px-4 py-8">
      {children}
    </main>
  </div>
);

const PartnerDetailPage: React.FC = () => {
  return (
    <Layout>
      <PartnerDetail />
    </Layout>
  );
};

export default PartnerDetailPage;
